const APP_NAME_MAP = {
  actifit: 'Actifit',
  ecency: 'Ecency',
  inleo: 'INLEO',
  leofinance: 'INLEO',
  leothreads: 'INLEO',
  'hive.blog': 'Hive.blog',
  peakd: 'PeakD',
  'peak.snaps': 'Peak Snaps',
  liketu: 'Liketu',
  'liketu.moments': 'Liketu Moments',
  keychain: 'Hive Keychain',
  esteem: 'eSteem',
  busy: 'Busy'
};

const toReadableName = (value) => {
  return value
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

const parseMetadataFromPost = (post) => {
  const rawMetadata = post?.json_metadata ?? post?.metadata ?? post?.jsonMetadata ?? null;
  if (!rawMetadata) {
    return null;
  }

  if (typeof rawMetadata === 'string') {
    try {
      return JSON.parse(rawMetadata);
    } catch (error) {
      return null;
    }
  }

  return typeof rawMetadata === 'object' ? rawMetadata : null;
};

const getRawAppKey = (metadata) => {
  if (!metadata || typeof metadata !== 'object') {
    return null;
  }

  const raw = metadata.app ?? metadata.application ?? metadata?.source?.app ?? null;
  if (typeof raw !== 'string') {
    return null;
  }

  const trimmed = raw.trim();
  return trimmed || null;
};

export const getPostAppInfo = (post, metadata) => {
  const metadataToUse = metadata && typeof metadata === 'object' ? metadata : parseMetadataFromPost(post);
  const rawKey = getRawAppKey(metadataToUse);
  if (!rawKey) {
    return null;
  }

  const baseKey = rawKey.split('/')[0]?.trim().toLowerCase();
  if (!baseKey) {
    return null;
  }

  const mappedName = APP_NAME_MAP[baseKey] || APP_NAME_MAP[rawKey.toLowerCase()];
  const fallbackName = toReadableName(baseKey);
  const name = mappedName || fallbackName || 'Unknown App';

  return {
    key: rawKey,
    name
  };
};
